/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useOutletContext } from "react-router-dom";
import BurnSwap from '../BurnSwap.js';

export default function Exit() {
  const [web3, seedAddress] = useOutletContext();

  return (
    <>
      <h2>Swap and Burn</h2>

      <p className="lead">
      As a Protocol holder you may swap your Protocol tokens in exchange for any
      other tokens that the protocol itself owns as part of the creation fee, proportionally to your share.
      The Protocol will then burn the swapped Protocol tokens, thereby reducing the supply.
      </p>
      <p className="lead">
      Note that you can demand a large list of tokens back, but the gas fee will increase proportionally. Choose wisely.
      </p>
      <div className="lead rounded border m-1 p-3">
        <BurnSwap web3={web3} seedAddress={seedAddress} />
      </div>
    </>
  );
}